<div  class="form-check form-switch">
    <input class="form-check-input" type="checkbox" [(ngModel)]="row.state" id="flexSwitchCheckDefault"
        [checked]="row.state === 1" data-bs-toggle="modal" data-bs-target="#modalSwitch" (change)="onToggleChange($event)"/>
</div>